import React, { Component } from 'react'
import { connect } from 'react-redux'
import { _DOTNET, _JAVA, _PHP } from '../../../actions/types'

class VaultEncResUpdateCC extends Component {
    getOrderId() {
        const { progLangId } = this.props;
        switch(progLangId) {
            case _DOTNET:
                return `"Test" + DateTime.Now.ToString("yyyyMMddhhmmss")`;
            case _JAVA:
                return `"Test"+createDate.getTime()`;
            case _PHP:
                return `'ord-'.date("dmy-G:i:s")`;
            default:
                return "";
        }
    }

    getValue(val, id) {
        return (
            <span className= {this.props.onEditId === id ? 'codeValue' : ''}>{val}</span>
        );
    }

    renderDOTNET() {
        const { storeId, apiToken  } = this.props;
         return (
            <pre className="sampleCode">
{
`namespace Moneris
{
using System;
public class TestCanadaEncResUpdateCC {
public static void Main(string[] args)
{
/******************* REQUEST VARIABLES*******************************/ 
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
string order_id = "Test" + DateTime.Now.ToString("yyyyMMddhhmmss"); 
string cust_id = "nqa";
string device_type = "idtech_bdk";
string crypt = "7";
string enc_track2 = "ENCRYPTEDTRACK2DATA";
string processing_country_code = "CA";
string data_key = "gF5IpsWD3s42r2TZxZyecE9Gs";
bool status_check = false;
EncResUpdateCC encresupdatecc = new EncResUpdateCC(); 
encresupdatecc.SetDataKey(data_key); 
encresupdatecc.SetCustId(cust_id); 
encresupdatecc.SetNote("Just a note2"); 
encresupdatecc.SetEmail("example1@test.com"); 
encresupdatecc.SetPhone("866-319-7450"); 
encresupdatecc.SetEncTrack2(enc_track2); 
encresupdatecc.SetDeviceType(device_type); 
encresupdatecc.SetCryptType(crypt);
/*************** Address Verification Service **********************/ 
AvsInfo avsCheck = new AvsInfo(); 
avsCheck.SetAvsStreetNumber("3300"); 
avsCheck.SetAvsStreetName("Bloor Street"); 
avsCheck.SetAvsZipCode("M2X2X2"); 
encresupdatecc.SetAvsInfo(avsCheck);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.SetProcCountryCode(processing_country_code);
mpgReq.SetTestMode(true); //false or comment out this line for production transactions 
mpgReq.SetStoreId(store_id);
mpgReq.SetApiToken(api_token); 
mpgReq.SetTransaction(encresupdatecc); 
mpgReq.SetStatusCheck(status_check); 
mpgReq.Send();
try
{
Receipt receipt = mpgReq.GetReceipt();
Console.WriteLine("DataKey = " + receipt.GetDataKey()); 
Console.WriteLine("ResponseCode = " + receipt.GetResponseCode()); 
Console.WriteLine("Message = " + receipt.GetMessage()); 
Console.WriteLine("TransDate = " + receipt.GetTransDate()); 
Console.WriteLine("TransTime = " + receipt.GetTransTime()); 
Console.WriteLine("Complete = " + receipt.GetComplete()); 
Console.WriteLine("TimedOut = " + receipt.GetTimedOut()); 
Console.WriteLine("ResSuccess = " + receipt.GetResSuccess()); 
Console.WriteLine("PaymentType = " + receipt.GetPaymentType());
//ResolveData
Console.WriteLine("\\nCust ID = " + receipt.GetResDataCustId()); 
Console.WriteLine("Phone = " + receipt.GetResDataPhone()); 
Console.WriteLine("Email = " + receipt.GetResDataEmail()); 
Console.WriteLine("Note = " + receipt.GetResDataNote()); 
Console.WriteLine("MaskedPan = " + receipt.GetResDataMaskedPan()); 
Console.WriteLine("Exp Date = " + receipt.GetResDataExpdate()); 
Console.WriteLine("Crypt Type = " + receipt.GetResDataCryptType()); 
Console.WriteLine("Avs Street Number = " + receipt.GetResDataAvsStreetNumber()); 
Console.WriteLine("Avs Street Name = " + receipt.GetResDataAvsStreetName()); 
Console.WriteLine("Avs Zipcode = " + receipt.GetResDataAvsZipcode()); 
Console.ReadLine();
}
catch (Exception e)
{
Console.WriteLine(e);
}
}
}
}
`}
            </pre>
        )
    }

    renderJAVA() {
        const { storeId, apiToken  } = this.props;
        return (
            <pre className="sampleCode">
{
`package Canada;
import JavaAPI.*;
public class TestCanadaEncResUpdateCC
{
public static void main(String args[])
{
string store_id = "`}{this.getValue(storeId, "storeId")}{`";
string api_token = "`}{this.getValue(apiToken, "apiToken")}{`";
String data_key = "PHTM1pun7VOaSCFM2xdeP2Sim";
String enc_track2 = "ENCRYPTEDTRACK2DATA";
String device_type = "idtech_bdk";
String phone = "55555555555";
String email = "test.user@moneris.com";
String note = "my note";
String cust_id = "customer2";
String crypt = "7";
String processing_country_code = "CA";
AvsInfo avsinfo = new AvsInfo();
avsinfo.setAvsStreetNumber("212");
avsinfo.setAvsStreetName("Smith Street");
avsinfo.setAvsZipcode("M1M1M1");
EncResUpdateCC enc_res_update_cc = new EncResUpdateCC (); 
enc_res_update_cc.setDataKey(data_key);
enc_res_update_cc.setAvsInfo(avsinfo);
enc_res_update_cc.setCustId(cust_id);
enc_res_update_cc.setEncTrack2(enc_track2); 
enc_res_update_cc.setDeviceType(device_type);
enc_res_update_cc.setPhone(phone);
enc_res_update_cc.setEmail(email);
enc_res_update_cc.setNote(note);
enc_res_update_cc.setCryptType(crypt);
HttpsPostRequest mpgReq = new HttpsPostRequest(); 
mpgReq.setProcCountryCode(processing_country_code);
mpgReq.setTestMode(true); //false or comment out this line for production transactions 
mpgReq.setStoreId(store_id);
mpgReq.setApiToken(api_token);
mpgReq.setTransaction(enc_res_update_cc);
mpgReq.send();
try
{
Receipt receipt = mpgReq.getReceipt();
System.out.println("DataKey = " + receipt.getDataKey()); 
System.out.println("ResponseCode = " + receipt.getResponseCode()); 
System.out.println("Message = " + receipt.getMessage()); 
System.out.println("TransDate = " + receipt.getTransDate()); 
System.out.println("TransTime = " + receipt.getTransTime()); 
System.out.println("Complete = " + receipt.getComplete()); 
System.out.println("TimedOut = " + receipt.getTimedOut()); 
System.out.println("ResSuccess = " + receipt.getResSuccess());
System.out.println("PaymentType = " + receipt.getPaymentType() + "\\n"); //Contents of ResolveData
System.out.println("Cust ID = " + receipt.getResCustId()); 
System.out.println("Phone = " + receipt.getResPhone()); 
System.out.println("Email = " + receipt.getResEmail()); 
System.out.println("Note = " + receipt.getResNote()); 
System.out.println("MaskedPan = " + receipt.getResMaskedPan()); 
System.out.println("Exp Date = " + receipt.getResExpDate()); 
System.out.println("Crypt Type = " + receipt.getResCryptType()); 
System.out.println("Avs Street Number = " + receipt.getResAvsStreetNumber()); 
System.out.println("Avs Street Name = " + receipt.getResAvsStreetName()); 
System.out.println("Avs Zipcode = " + receipt.getResAvsZipcode());
}
catch (Exception e) { e.printStackTrace(); }
}
}
`}
</pre>
        )
    }

    renderPHP() {
        const { storeId, apiToken  } = this.props;

        return (
            <pre className="sampleCode">
{`<?php
require "../../mpgClasses.php";
/**************************** Request Variables *******************************/ 
$store_id='`}{this.getValue(storeId, "storeId")}{`';
$api_token='`}{this.getValue(apiToken, "apiToken")}{`';
/************************* Transactional Variables ****************************/ 
$type='enc_res_update_cc';
$data_key='F91LyeEJjv8OvpOdmXYWKh7dV';
$cust_id='cust2';
$phone = '4169996999';
$email = 'bob@email.com';
$note = 'note4';
$enc_track2 = 'ENCRYPTEDTRACK2DATA';
$device_type='idtech_bdk';
$crypt_type='7';
$avs_street_number = '3300';
$avs_street_name = 'bloor street west';
$avs_zipcode = 'm8x2x3';
/*********************** Transactional Associative Array **********************/ 
$txnArray=array('type'=>$type,
'data_key'=>$data_key,
'cust_id'=>$cust_id,
'phone'=>$phone, 
'email'=>$email, 
'note'=>$note, 
'enc_track2'=>$enc_track2, 
'device_type'=>$device_type, 
'crypt_type'=>$crypt_type );
/********************** AVS Associative Array *********************************/
 $avsTemplate = array(
'avs_street_number' => $avs_street_number,
'avs_street_name' => $avs_street_name,
'avs_zipcode' => $avs_zipcode
);
/************************** AVS Object ***************************************/
$mpgAvsInfo = new mpgAvsInfo ($avsTemplate);
/**************************** Transaction Object *****************************/
$mpgTxn = new mpgTransaction($txnArray);
$mpgTxn->setAvsInfo($mpgAvsInfo);
/****************************** Request Object *******************************/
$mpgRequest = new mpgRequest($mpgTxn);
$mpgRequest->setProcCountryCode("CA"); //"US" for sending transaction to US environment 
$mpgRequest->setTestMode(true); //false or comment out this line for production transactions 
/***************************** HTTPS Post Object *****************************/ 
$mpgHttpPost =new mpgHttpsPost($store_id,$api_token,$mpgRequest); 
/******************************* Response ************************************/ 
$mpgResponse=$mpgHttpPost->getMpgResponse();
print("\\nDataKey = " . $mpgResponse->getDataKey());
print("\\nResponseCode = " . $mpgResponse->getResponseCode());
print("\\nMessage = " . $mpgResponse->getMessage());
print("\\nTransDate = " . $mpgResponse->getTransDate());
print("\\nTransTime = " . $mpgResponse->getTransTime());
print("\\nComplete = " . $mpgResponse->getComplete());
print("\\nTimedOut = " . $mpgResponse->getTimedOut());
print("\\nResSuccess = " . $mpgResponse->getResSuccess());
print("\\nPaymentType = " . $mpgResponse->getPaymentType());
//----------------- ResolveData ------------------------------
print("\\n\\nCust ID = " . $mpgResponse->getResDataCustId());
print("\\nPhone = " . $mpgResponse->getResDataPhone());
print("\\nEmail = " . $mpgResponse->getResDataEmail());
print("\\nNote = " . $mpgResponse->getResDataNote());
print("\\nMasked Pan = " . $mpgResponse->getResDataMaskedPan());
print("\\nExp Date = " . $mpgResponse->getResDataExpDate());
print("\\nCrypt Type = " . $mpgResponse->getResDataCryptType());
print("\\nAvs Street Number = " . $mpgResponse->getResDataAvsStreetNumber());
print("\\nAvs Street Name = " . $mpgResponse->getResDataAvsStreetName());
print("\\nAvs Zipcode = " . $mpgResponse->getResDataAvsZipcode());
?>
`}
            </pre>
        )
    }

    render() {
        switch(this.props.progLangId) {
            case _DOTNET: 
                return this.renderDOTNET()
            case _JAVA:
                return this.renderJAVA()
            case _PHP:
                return this.renderPHP()

            default:
                return null
        }
        
    }
}

const mapStateToProps = state => {
    const { mode } = state.common.sideNav;
    const {loading } = state.vault.main;
    const { storeId, apiToken, order_id, onEditId } = state.vault.main.config;
    return { mode, storeId, apiToken, order_id, onEditId ,loading, progLangId: state.common.progLangList.selection };
  }
  
  export default connect(mapStateToProps, {})(VaultEncResUpdateCC)